<template>
  <!-- 星空父容器 relative基准 -->
  <div class="star-wrap">
    <!-- 三层视差星空层 -->
    <div class="star-layer layer1" ref="layer1"></div>
    <div class="star-layer layer2" ref="layer2"></div>
    <div class="star-layer layer3" ref="layer3"></div>
  </div>
</template>

<script>
export default {
  name: 'StarrySky',
  mounted() {
    // 生成星星函数 count数量 size星星尺寸 wrap容器
    const createStarList = (count, size, wrap) => {
      let shadowStr = ''
      // 生成上半区0~4000px星星
      for (let i = 0; i < count; i++) {
        const x = Math.floor(Math.random() * 2500)
        const y = Math.floor(Math.random() * 4000)
        shadowStr += `${x}px ${y}px #fff,`
      }
      // 下半区副本2000~6000px，专门用来无缝衔接
      for (let i = 0; i < count; i++) {
        const x = Math.floor(Math.random() * 2500)
        const y = Math.floor(Math.random() * 4000 + 2000)
        shadowStr += `${x}px ${y}px #fff,`
      }
      // 去除最后逗号
      shadowStr = shadowStr.slice(0, -1)
      wrap.style.width = `${size}px`
      wrap.style.height = `${size}px`
      wrap.style.boxShadow = shadowStr
    }
    // 每层星星数量：小星星最多、大星星偏少
    createStarList(400, 1, this.$refs.layer1) // 400颗1px小星星
    createStarList(280, 2, this.$refs.layer2) // 280颗2px中星
    createStarList(160, 3, this.$refs.layer3) // 160颗3px大星星
  }
}
</script>

<style scoped>
/* 父容器 relative，铺满页面 */
.star-wrap {
  /* position: relative; */
  width: 100%;
  min-height: 100vh;
  /* background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%); */
  /* overflow: hidden; */
}

/* 所有星星层 absolute定位 */
.star-layer {
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
  animation: scrollStar linear infinite;
  will-change: transform; /* 优化动画性能 */
}

/* 视差速度：越小越快 */
.layer1 {
  animation-duration: 50s;
}
.layer2 {
  animation-duration: 100s;
}
.layer3 {
  animation-duration: 150s;
}

/* 无缝核心动画：移动2000px刚好拼接下方副本星星 */
@keyframes scrollStar {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-2000px);
  }
}
</style>
